import { z } from "zod";

export const bonusSchema = z.object({
  assign: z.boolean(),
  bonusId: z.number(),
  amount: z.number(),
  duration: z.nullable(z.number()),
  name: z.nullable(z.string()),
  maturity: z.nullable(z.number()),
  accountNumberPrefix: z.nullable(z.string()),
  accountNumber: z.nullable(z.string()),
  accountNumberBankId: z.nullable(z.string()),
  bonusInSelfcare: z.boolean(),
});
